// extracted by mini-css-extract-plugin
export default {"tupacGrid":"zl-z","tupacHeader":"Al-z","tupacHeader2":"Bl-z","tupacMenu":"Cl-z","tupacMenu2":"Dl-z","tupacMain":"El-z","tupacMain2":"Fl-z"};